import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'marketplaces', to: '/ebay/marketplaces', label: 'Marketplaces' },
];

function SidebarEbay(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarEbay;
